import { requestTimeout, handleResponse } from '../helpers'


const apiUrl = process.env.REACT_APP_API_URL
const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME

const base_uri = "clientAccounts"

export const clientPaymentAccountsApi = {
    _get,
    _create,
    _credit,
};



async function _get(clientId) {
    let token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify({'client_id': clientId})
    };
    let url = apiUrl + base_uri + "/get"
    return requestTimeout(apiMaxTime, fetch(url, requestOptions))
        .then(handleResponse)
        .then((response) => {
            return response
        })


}

async function _create(data) {
    let token = localStorage.getItem(accessToken)
    const requestOptions = { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token }, body: JSON.stringify(data) }
    return requestTimeout(apiMaxTime, fetch(apiUrl + base_uri + '/create', requestOptions)).then(handleResponse)
}

async function _credit(data) {
    let token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data),
    };
    let url = apiUrl + base_uri + "/creditAccount"
    return requestTimeout(apiMaxTime, fetch(url, requestOptions))
        .then(handleResponse)
        .then((response) => {
            return response
        })


}
